export const companionRule = {
  id: 'companion',
  name: 'Companion Ads',
  description: 'If companion ads are declared, they should be retrievable',

  check(session) {
    const adStarted = session.events.find(e => e.type === 'adstarted');
    if (!adStarted) {
      return { status: 'na', message: 'No ad started' };
    }

    // This rule mostly serves as a placeholder for companion verification.
    // True companion validation requires VAST XML inspection, which is
    // handled in the companion panel UI. Here we just check for basic viability.
    const errors = session.events.filter(e => e.type === 'aderror');
    if (errors.length > 0) {
      return { status: 'na', message: 'Ad errored; companion check skipped' };
    }

    return { status: 'na', message: 'Companion presence must be verified manually or via VAST XML inspection' };
  },
};
